import { render, staticRenderFns } from "./AppHealth.vue?vue&type=template&id=9cd00722&scoped=true"
import script from "./AppHealth.vue?vue&type=script&lang=js"
export * from "./AppHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd00722",
  null
  
)

export default component.exports